<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @open="open"
             @closed="closed"
             width="800px">
    <el-tabs v-model="activeName" style="height: 500px;" :key="pattern">
      <el-tab-pane name="1" style="padding: 0 60px">
        <template #label>
          <span style="padding: 0 50px; cursor: pointer">用户信息</span>
        </template>
        <el-form label-position="right" label-width="100px" :model="user" :rules="rules" ref="user">
          <div style="display: flex">
            <div style="width: 0; flex-grow: 1; margin-right: 30px">
              <el-form-item label="所属机构">
                <label class="value">{{organ.label}}</label>
              </el-form-item>

              <input-form-item label="手机" prop="cellphone"></input-form-item>

              <el-form-item label="微信绑定">
                <label v-if="!user.openid" class="value">未绑定</label>
                <template v-else>
                  <label class="value">已绑定</label>
                  <el-button v-if="!controlReadOnly" size="big"
                             style="margin-left: 10px; padding-top: 5px; padding-bottom: 5px"
                             @click="unbind">解除绑定
                  </el-button>
                </template>
              </el-form-item>

              <form-item label="职位" prop="positions" class-name="Position">
                <position-select v-model="user.positions" :organ-type="organ.type"
                                 @change="changePositions" class="fullwidth">
                </position-select>
              </form-item>

              <template v-if="hasTechnicianPosition">
                <remote-form-item label="技师类型" prop="technicianType" class-name="TechnicianType"></remote-form-item>
                <remote-form-item :disabled="!needTeam" label="所属工组" prop="teamId" class-name="Team"></remote-form-item>
              </template>
            </div>
            <div style="width: 0; flex-grow: 1">
              <input-form-item label="姓名" prop="name"></input-form-item>

              <input-form-item label="登陆密码" prop="password" empty-value="********" :validate="isNew"
                               @change="changePassword"></input-form-item>

              <div class="image">
                <el-form-item label="用户头像" style="margin-bottom: 8px">
                  <div style="display: flex">
                    <el-upload
                      accept="image/png, image/jpeg"
                      :show-file-list="false"
                      :action="$baseUrl + 'api/uploadImage'"
                      :on-success="uploadAvatarSuccess"
                      :on-error="uploadAvatarFailed"
                      :before-upload="beforeAvatarUpload">
                      <!-- avatar 的 key 必须等于 src，否则修改 src 不会刷新!!! -->
                      <!--:src="baseUrl + 'image/' + user.avatarUrl"-->
                      <el-avatar shape="square" :size="74"
                                 :src="user.avatarUrl"
                                 style="margin-top: 8px; flex-shrink: 0"
                                 :key="user.avatarUrl">
                      </el-avatar>
                    </el-upload>
                    <div :style="{'margin-left': readOnly ? '36px' : '16px'}">
                      状态
                      <label v-if="readOnly" class="value">{{user.status | status}}</label>
                      <el-radio-group v-else v-model="user.status" style="margin-left: 36px">
                        <el-radio class="status-enable" :label="0">{{0 | status}}</el-radio>
                        <el-radio class="status-disable" :label="1">{{1 | status}}</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <transition name="fade">
                <div v-if="hasTechnicianPosition">
                  <remote-form-item label="技师等级" prop="technicianLevelId" class-name="TECHNICIAN_LEVEL">
                  </remote-form-item>
                  <input-number-form-item label="最大施工数" prop="maxWorkNum"></input-number-form-item>
                </div>
              </transition>
            </div>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="2">
        <template #label>
          <span style="padding: 0 50px; cursor: pointer">权限信息</span>
        </template>
        <div>
          <el-form label-position="right" label-width="100px">
            <el-checkbox-group v-model="user.permissions">
              <el-form-item v-for="authorityType of $store.state.data.AuthorityType" :label="authorityType.name"
                            :key="authorityType.id">
                <el-checkbox v-for="authority of authorityListByType(authorityType.id)"
                             :key="authority.id"
                             :label="authority.id"
                             style="width: 100px;"
                             size="mini"
                             :disabled="readOnly">
                  {{authority.name}}
                </el-checkbox>
              </el-form-item>
            </el-checkbox-group>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

  import { shareDataMixin } from '@/views/mixins/ShareData'
  import { addUser, getData, unbindOpenid, updateUser } from '@/utils/request'
  import PositionSelect from '@/components/selector/PositionSelect'
  import InputFormItem from '@/components/form/InputFormItem'
  import FormItem from '@/components/form/FormItem'
  import RemoteFormItem from '@/components/form/RemoteFormItem'
  import InputNumberFormItem from '@/components/form/InputNumberFormItem'
  import { isMobile } from '@/utils/validate'

  export default {
    name: 'EditUserDialog',
    mixins: [shareDataMixin],
    components: {
      InputNumberFormItem,
      RemoteFormItem,
      FormItem,
      InputFormItem,
      PositionSelect
    },
    props: {
      user: {
        type: Object,
        required: true
      },
      organ: {
        type: Object,
        required: true
      },
      readOnly: Boolean
    },
    data () {
      return {
        activeName: '1',
        rules: {
          name: [
            {
              required: true,
              message: '请输入姓名',
              trigger: 'blur'
            }
          ],
          cellphone: [
            {
              required: true,
              trigger: 'blur',
              validator (rule, value, callback) {
                if (!isMobile(value)) {
                  callback(new Error('请输入正确手机号码'))
                } else {
                  callback()
                }
              }
            }
          ],
          password: [
            {
              required: true,
              trigger: 'blur',
              message: '请输入密码'
            }
          ],
          positions: [
            {
              required: true,
              message: '请选择职位',
              trigger: 'change'
            }
          ],
          technicianType: [
            {
              required: true,
              message: '请选择技师类型',
              trigger: 'change'
            }
          ],
          teamId: [
            {
              required: true,
              message: '请选择工组',
              trigger: 'change'
            }
          ],
          technicianLevelId: [
            {
              required: true,
              message: '请选择技师等级',
              trigger: 'change'
            }
          ]
        },
        positionAuthorityMap: {},
        hasTechnicianPosition: null,
        passwordChanged: false
      }
    },
    created () {
      this.$store.dispatch('data/kvList', 'AuthorityType')
      this.$store.dispatch('data/kvList', 'Authority')
      getData('positionAuthorityMap').then(response => {
        this.positionAuthorityMap = response.data
      })
    },
    methods: {
      open () {
        this.hasTechnicianPosition = this.user.positions.indexOf('TECHNICIAN_PO') !== -1
        this.user.password = this.isNew ? '' : '******'
        this.passwordChanged = false
      },
      closed () {
        this.activeName = '1'
        this.user.permissions = []
        if (!this.readOnly) {
          this.$refs.user.resetFields()
        }
      },
      add () {
        this.$refs.user.validate(valid => {
          if (!valid) return

          const user = this.$_.cloneDeep(this.user)
          if (this.organ.type === 'SHOP' || this.organ.type === 'WORKSHOP') {
            user.shopId = this.organ.id
          }
          user.account = user.cellphone
          addUser(user).then(response => {
            this.$emit('add', response.data)
            this.hide()
          })
        })
      },
      save () {
        this.$refs.user.validate(valid => {
          if (!valid) return

          const user = this.$_.cloneDeep(this.user)
          if (!this.passwordChanged) {
            user.password = null
          }
          updateUser(user).then(() => {
            this.$emit('update', this.user)
            this.hide()
          })
        })
      },
      cancel () {
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      },
      changePositions (positions) {
        const hasTechnicianPosition = positions.indexOf('TECHNICIAN_PO') !== -1
        if (this.hasTechnicianPosition !== hasTechnicianPosition) {
          this.user.teamId = null
          this.user.technicianType = null
          this.user.technicianLevelId = null
          this.user.maxWorkNum = null
          this.hasTechnicianPosition = hasTechnicianPosition
        }
        this.resetAuthority()
      },
      resetAuthority () {
        this.user.permissions = []
        for (const position of this.user.positions) {
          for (const authority of this.positionAuthorityMap[position]) {
            this.user.permissions.push(authority)
          }
        }
      },
      authorityListByType (authorityTypeId) {
        return (this.$store.state.data.Authority || []).filter(authority => authority.type === authorityTypeId)
      },
      uploadAvatarSuccess (res, file) {
        // if (res.data) {
        // this.user.avatarUrl = URL.createObjectURL(file.raw)
        // this.user.avatarUrl = res.data
        // }

        const reader = new FileReader()
        reader.readAsDataURL(file.raw)
        const user = this.user
        reader.onload = function (e) {
          user.avatarUrl = this.result
        }
      },
      uploadAvatarFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeAvatarUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isLt2M
      },
      unbind () {
        unbindOpenid(this.user).then(() => {
          this.user.openid = undefined
        })
      },
      changePassword () {
        this.passwordChanged = true
      }
    },
    computed: {
      isNew () {
        return !this.user.id
      },
      controlReadOnly () {
        return !this.isNew && this.readOnly
      },
      title () {
        if (this.isNew) return '新增用户'
        return this.readOnly ? '编辑用户' : '查看用户'
      },
      pattern () {
        if (this.isNew) return 'NEW'
        if (this.readOnly) return 'READ'
        return 'EDIT'
      },
      needTeam () {
        return this.hasTechnicianPosition &&
          (this.user.technicianType !== 'CAR_WASH' && this.user.technicianType !== 'MACHINE_REPAIR')
      }
    },
    watch: {
      needTeam (value) {
        if (!value) {
          this.user.teamId = null
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    .el-radio.status-enable {
      margin-right: 4px;
    }

    .el-radio.status-disable {
      margin-top: 8px;
      margin-right: 0;
    }

    .el-radio__label {
      padding-left: 4px;
    }

    .el-checkbox__input.is-disabled + span.el-checkbox__label {
      color: #606266;
    }

    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
      border-color: #606266;
    }
  }

  /deep/ .image {
    .el-form-item--small.el-form-item {
      /*margin-bottom: 10px;*/
    }
  }
</style>
